import {
  FormField,
  FormControl,
  FormItem,
  Input as DefaultInput,
  Dialog,
  DialogContent,
  DialogTrigger,
  DialogHeader,
  DialogTitle,
} from "@repo/ui";
import { Label } from "./label";
import { BiInfoCircle } from "react-icons/bi";
import { GitFork } from "lucide-react";
import { MdList } from "react-icons/md";
export default function FormInput({
  label,
  rules,
  name,
  isRequired,
  info,
  disabled,
  errors,
  control,
  inputProps,
  formControlProps,
  onBlur,
  detailsView,
  recordsView,
  detailContentClass,
  recordContentClass,
  hideIcons,
}) {
  return (
    <FormField
      control={control}
      name={name}
      rules={rules ? { ...rules } : {}}
      render={({ field }) => (
        <FormItem>
          <Label label={label} isRequired={isRequired} />

          <FormControl>
            <div className="flex flex-col">
              <div className="flex flex-row items-center gap-[1px]">
                <DefaultInput
                  {...field}
                  {...inputProps}
                  disabled={disabled}
                  onBlur={() => {
                    if (onBlur) {
                      onBlur(field.value);
                    }
                  }}
                  style={
                    errors[name]
                      ? {
                          ...(inputProps?.style ? inputProps.style : {}),
                          borderColor: "red",
                        }
                      : { ...(inputProps?.style ? inputProps.style : {}) }
                  }
                />
                {hideIcons ? (
                  <></>
                ) : (
                  <>
                    <Dialog
                      onOpenChange={() => {}}
                      style={{ maxWidth: "1400px" }}
                    >
                      <DialogTrigger asChild>
                        <BiInfoCircle
                          title="View Information"
                          fontSize={"16px"}
                          style={{
                            visibility: detailsView ? "visible" : "hidden",
                            fontSize: "16px",
                            color: "hsl(var(--secondary))",
                          }}
                        />
                      </DialogTrigger>
                      <DialogHeader>
                        <DialogTitle></DialogTitle>
                      </DialogHeader>
                      <DialogContent
                        className={detailContentClass}
                        onOpenAutoFocus={(e) => {
                          e.preventDefault();
                        }}
                      >
                        {detailsView || <></>}
                      </DialogContent>
                    </Dialog>
                    <Dialog onOpenChange={() => {}}>
                      <DialogTrigger asChild>
                        <div title={"View Records"}>
                          <GitFork
                            style={{
                              transform: "rotate(90deg)",
                              visibility: recordsView ? "visible" : "hidden",
                              width: "16px",
                              color: "hsl(var(--secondary))",
                            }}
                          />
                        </div>
                      </DialogTrigger>
                      <DialogHeader>
                        <DialogTitle></DialogTitle>
                      </DialogHeader>
                      <DialogContent
                        className={recordContentClass}
                        onOpenAutoFocus={(e) => {
                          e.preventDefault();
                        }}
                      >
                        {recordsView || <></>}
                      </DialogContent>
                    </Dialog>
                  </>
                )}
              </div>
              {info ? (
                <p className="text-black-500 text-xs">{info || ""}</p>
              ) : (
                <></>
              )}
              {errors ? (
                errors[name] ? (
                  <p className="text-destructive text-xs">
                    {errors[name].message || "Please Select Date!"}
                  </p>
                ) : (
                  <></>
                )
              ) : (
                <></>
              )}
            </div>
          </FormControl>
        </FormItem>
      )}
    />
  );
}
